import React, { createRef, PureComponent } from "react";
import Draggable from "react-draggable";
import "./Hits.css";

const speed = 2;

export default class Hits extends PureComponent {
  state = {
    position: {
      x: Math.random() * this.props.dimensions.width * 0.6,
      y: Math.random() * this.props.dimensions.height * 0.6
    },
    vector: {
      x: 1,
      y: 1
    }
  };

  constructor(props) {
    super(props);
    this.ref = createRef();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.isSafewordShouted && !prevProps.isSafewordShouted) {
      this.props.popScene(this.constructor);
    }
    if (this.props.doneSharing && !prevProps.doneSharing) {
      this.cancelAnimation();
    }
  }

  componentDidMount() {
    this.updatePosition();
  }

  updateVector(position, vector, axis) {
    if (!this.ref.current) {
      return 1;
    }
    // offsetWidth
    const side = axis === "x" ? "Width" : "Height";
    if (vector[axis] < 0 && position[axis] < 0) {
      return 1;
    }

    const limit = this.props.dimensions[side.toLowerCase()];
    const size = this.ref.current[`offset${side}`];
    if (vector[axis] > 0 && position[axis] + size > limit) {
      return -1;
    }

    return vector[axis];
  }

  updatePosition = () => {
    this.ref.current &&
      this.setState(({ position, vector }) => {
        return {
          position: {
            x: position.x + vector.x * speed,
            y: position.y + vector.y * speed
          },
          vector: {
            x: this.updateVector(position, vector, "x"),
            y: this.updateVector(position, vector, "y")
          }
        };
      });
    this.animation = requestAnimationFrame(this.updatePosition);
  };

  cancelAnimation() {
    cancelAnimationFrame(this.animation);
  }

  componentWillUnmount() {
    this.cancelAnimation();
  }

  render() {
    if (!this.props.hits) {
      return null;
    }
    return (
      <div className="hits">
        <Draggable position={this.state.position}>
          <div>
            <div ref={this.ref} className="hits-element">
              <h1>{this.props.hits}</h1>
              <p>VISITOR COUNT</p>
            </div>
          </div>
        </Draggable>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Hits/Hits.js